var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeDarkGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.375C6.46447 9.375 5.625 8.53553 5.625 7.5C5.625 6.46447 6.46447 5.625 7.5 5.625C8.53553 5.625 9.375 6.46447 9.375 7.5C9.375 8.53553 8.53553 9.375 7.5 9.375Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.43301 4.13613C4.71387 3.25781 6.08467 2.8125 7.50703 2.8125C8.78701 2.8125 10.0348 3.19336 11.2157 3.93984C12.4066 4.69424 13.5741 6.06445 14.5312 7.5C13.7572 8.78906 12.6984 10.1145 11.5957 10.8744C10.3307 11.7457 8.95518 12.1875 7.50703 12.1875C6.07148 12.1875 4.69893 11.746 3.42598 10.8753C2.30537 10.1074 1.23896 8.78379 0.46875 7.5C1.2416 6.22764 2.31152 4.90547 3.43301 4.13613ZM7.5 10.3125C8.05626 10.3125 8.60003 10.1475 9.06254 9.83851C9.52505 9.52947 9.88554 9.09021 10.0984 8.5763C10.3113 8.06238 10.367 7.49688 10.2585 6.95131C10.1499 6.40574 9.88207 5.9046 9.48874 5.51126C9.0954 5.11793 8.59426 4.85006 8.04869 4.74154C7.50312 4.63302 6.93762 4.68872 6.4237 4.90159C5.90979 5.11446 5.47053 5.47495 5.16149 5.93746C4.85245 6.39997 4.6875 6.94374 4.6875 7.5C4.68835 8.24566 4.98494 8.96053 5.5122 9.4878C6.03947 10.0151 6.75434 10.3116 7.5 10.3125Z",
    fill: "#888888"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeDarkGray);
export default __webpack_public_path__ + "static/media/eye-dark-gray.0a11a439.svg";
export { ForwardRef as ReactComponent };